/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OneApp Students API
 * OneApp API for Students
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AinaEventResponse,
  AinaRequestBody,
  ClassesByTimelineRequestDto,
  CreateCyotPaperDTO,
  CreatePopupDTO,
  EnrollForScoreProgramResponseDto,
  GetBasicExamReportDTO,
  GetCyotPapersDTO,
  GetDeepLinksProgramsDTO,
  GetDeepLinksTestsDTO,
  GetExamReportsDTO,
  GetMyPastClasses,
  GetProgramsLiveClassCohortHistoryDTO,
  GetStudentScheduleSummaryDto,
  GetStudentToDoClassesAssignmentsDto,
  GetStudentToDoTestsDto,
  GetStudentUnscheduledTestseriesDTO,
  GetStudentsCardsDTO,
  GetSubscriptionStatusDTO,
  GetSuggestedProgramsDTO,
  GetTestSeriesDTO,
  SaveStudentExamApplicationDto,
  SaveStudentfeedbackDTO,
  SaveStudentsCurrentProgramsDto,
  SaveStudentsGuidelinesPreferencesDTO,
  ShareCyotPapersDTO,
  StudentAttemptedExamsDto,
  StudentsControllerEnrollForScoreProgramParams,
  StudentsControllerGetDeepLinkParams,
  StudentsControllerGetEnrolledProgramsParams,
  StudentsControllerGetExamsParams,
  StudentsControllerGetMyProgramsParams,
  TriggerLiveClassEventsToWebengageDto,
  UpdateSuspiciousActivityDto,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const studentsControllerGetAllCountriesWithPhoneNumbers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/students/phone-numbers-by-country`, method: "GET", signal },
    options,
  );
};

export const getStudentsControllerGetAllCountriesWithPhoneNumbersQueryKey =
  () => {
    return [`/students/phone-numbers-by-country`] as const;
  };

export const getStudentsControllerGetAllCountriesWithPhoneNumbersQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
    >,
    TError = unknown,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getStudentsControllerGetAllCountriesWithPhoneNumbersQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
      >
    > = ({ signal }) =>
      studentsControllerGetAllCountriesWithPhoneNumbers(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type StudentsControllerGetAllCountriesWithPhoneNumbersQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
    >
  >;
export type StudentsControllerGetAllCountriesWithPhoneNumbersQueryError =
  unknown;

export function useStudentsControllerGetAllCountriesWithPhoneNumbers<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
  >,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
          >,
          TError,
          Awaited<
            ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetAllCountriesWithPhoneNumbers<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
          >,
          TError,
          Awaited<
            ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetAllCountriesWithPhoneNumbers<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useStudentsControllerGetAllCountriesWithPhoneNumbers<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetAllCountriesWithPhoneNumbers>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getStudentsControllerGetAllCountriesWithPhoneNumbersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const studentsControllerGetEnrolledPrograms = (
  params: StudentsControllerGetEnrolledProgramsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/students/enrolled-programs`, method: "GET", params, signal },
    options,
  );
};

export const getStudentsControllerGetEnrolledProgramsQueryKey = (
  params?: StudentsControllerGetEnrolledProgramsParams,
) => {
  return [`/students/enrolled-programs`, ...(params ? [params] : [])] as const;
};

export const getStudentsControllerGetEnrolledProgramsQueryOptions = <
  TData = Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
  TError = unknown,
>(
  params: StudentsControllerGetEnrolledProgramsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStudentsControllerGetEnrolledProgramsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>
  > = ({ signal }) =>
    studentsControllerGetEnrolledPrograms(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StudentsControllerGetEnrolledProgramsQueryResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>
>;
export type StudentsControllerGetEnrolledProgramsQueryError = unknown;

export function useStudentsControllerGetEnrolledPrograms<
  TData = Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
  TError = unknown,
>(
  params: StudentsControllerGetEnrolledProgramsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetEnrolledPrograms<
  TData = Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
  TError = unknown,
>(
  params: StudentsControllerGetEnrolledProgramsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetEnrolledPrograms<
  TData = Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
  TError = unknown,
>(
  params: StudentsControllerGetEnrolledProgramsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useStudentsControllerGetEnrolledPrograms<
  TData = Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
  TError = unknown,
>(
  params: StudentsControllerGetEnrolledProgramsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetEnrolledPrograms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getStudentsControllerGetEnrolledProgramsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const studentsControllerGetMyPrograms = (
  params?: StudentsControllerGetMyProgramsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/students/my-programs`, method: "GET", params, signal },
    options,
  );
};

export const getStudentsControllerGetMyProgramsQueryKey = (
  params?: StudentsControllerGetMyProgramsParams,
) => {
  return [`/students/my-programs`, ...(params ? [params] : [])] as const;
};

export const getStudentsControllerGetMyProgramsQueryOptions = <
  TData = Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
  TError = unknown,
>(
  params?: StudentsControllerGetMyProgramsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStudentsControllerGetMyProgramsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>
  > = ({ signal }) =>
    studentsControllerGetMyPrograms(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StudentsControllerGetMyProgramsQueryResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>
>;
export type StudentsControllerGetMyProgramsQueryError = unknown;

export function useStudentsControllerGetMyPrograms<
  TData = Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
  TError = unknown,
>(
  params: undefined | StudentsControllerGetMyProgramsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetMyPrograms<
  TData = Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
  TError = unknown,
>(
  params?: StudentsControllerGetMyProgramsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetMyPrograms<
  TData = Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
  TError = unknown,
>(
  params?: StudentsControllerGetMyProgramsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useStudentsControllerGetMyPrograms<
  TData = Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
  TError = unknown,
>(
  params?: StudentsControllerGetMyProgramsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetMyPrograms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getStudentsControllerGetMyProgramsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const studentsControllerEnrollForScoreProgram = (
  params: StudentsControllerEnrollForScoreProgramParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<EnrollForScoreProgramResponseDto>(
    {
      url: `/students/enroll-for-score-program`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getStudentsControllerEnrollForScoreProgramQueryKey = (
  params?: StudentsControllerEnrollForScoreProgramParams,
) => {
  return [
    `/students/enroll-for-score-program`,
    ...(params ? [params] : []),
  ] as const;
};

export const getStudentsControllerEnrollForScoreProgramQueryOptions = <
  TData = Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
  TError = unknown,
>(
  params: StudentsControllerEnrollForScoreProgramParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStudentsControllerEnrollForScoreProgramQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>
  > = ({ signal }) =>
    studentsControllerEnrollForScoreProgram(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StudentsControllerEnrollForScoreProgramQueryResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>
>;
export type StudentsControllerEnrollForScoreProgramQueryError = unknown;

export function useStudentsControllerEnrollForScoreProgram<
  TData = Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
  TError = unknown,
>(
  params: StudentsControllerEnrollForScoreProgramParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerEnrollForScoreProgram<
  TData = Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
  TError = unknown,
>(
  params: StudentsControllerEnrollForScoreProgramParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerEnrollForScoreProgram<
  TData = Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
  TError = unknown,
>(
  params: StudentsControllerEnrollForScoreProgramParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useStudentsControllerEnrollForScoreProgram<
  TData = Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
  TError = unknown,
>(
  params: StudentsControllerEnrollForScoreProgramParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerEnrollForScoreProgram>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getStudentsControllerEnrollForScoreProgramQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const studentsControllerGetUsersSubscriptionStatus = (
  getSubscriptionStatusDTO: GetSubscriptionStatusDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/subscription-status`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getSubscriptionStatusDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetUsersSubscriptionStatusMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetUsersSubscriptionStatus>>,
    TError,
    { data: GetSubscriptionStatusDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetUsersSubscriptionStatus>>,
  TError,
  { data: GetSubscriptionStatusDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerGetUsersSubscriptionStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetUsersSubscriptionStatus>>,
    { data: GetSubscriptionStatusDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetUsersSubscriptionStatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetUsersSubscriptionStatusMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof studentsControllerGetUsersSubscriptionStatus>>
  >;
export type StudentsControllerGetUsersSubscriptionStatusMutationBody =
  GetSubscriptionStatusDTO;
export type StudentsControllerGetUsersSubscriptionStatusMutationError = unknown;

export const useStudentsControllerGetUsersSubscriptionStatus = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetUsersSubscriptionStatus>>,
      TError,
      { data: GetSubscriptionStatusDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetUsersSubscriptionStatus>>,
  TError,
  { data: GetSubscriptionStatusDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetUsersSubscriptionStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetExams = (
  params: StudentsControllerGetExamsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/students/supported-exams/exams`, method: "GET", params, signal },
    options,
  );
};

export const getStudentsControllerGetExamsQueryKey = (
  params?: StudentsControllerGetExamsParams,
) => {
  return [
    `/students/supported-exams/exams`,
    ...(params ? [params] : []),
  ] as const;
};

export const getStudentsControllerGetExamsQueryOptions = <
  TData = Awaited<ReturnType<typeof studentsControllerGetExams>>,
  TError = unknown,
>(
  params: StudentsControllerGetExamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetExams>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStudentsControllerGetExamsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof studentsControllerGetExams>>
  > = ({ signal }) =>
    studentsControllerGetExams(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof studentsControllerGetExams>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StudentsControllerGetExamsQueryResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetExams>>
>;
export type StudentsControllerGetExamsQueryError = unknown;

export function useStudentsControllerGetExams<
  TData = Awaited<ReturnType<typeof studentsControllerGetExams>>,
  TError = unknown,
>(
  params: StudentsControllerGetExamsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetExams>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerGetExams>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerGetExams>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetExams<
  TData = Awaited<ReturnType<typeof studentsControllerGetExams>>,
  TError = unknown,
>(
  params: StudentsControllerGetExamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetExams>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerGetExams>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerGetExams>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetExams<
  TData = Awaited<ReturnType<typeof studentsControllerGetExams>>,
  TError = unknown,
>(
  params: StudentsControllerGetExamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetExams>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useStudentsControllerGetExams<
  TData = Awaited<ReturnType<typeof studentsControllerGetExams>>,
  TError = unknown,
>(
  params: StudentsControllerGetExamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetExams>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getStudentsControllerGetExamsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const studentsControllerUpdateTestAttempt = (
  studentAttemptedExamsDto: StudentAttemptedExamsDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/attempt-test`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: studentAttemptedExamsDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerUpdateTestAttemptMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerUpdateTestAttempt>>,
    TError,
    { data: StudentAttemptedExamsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerUpdateTestAttempt>>,
  TError,
  { data: StudentAttemptedExamsDto },
  TContext
> => {
  const mutationKey = ["studentsControllerUpdateTestAttempt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerUpdateTestAttempt>>,
    { data: StudentAttemptedExamsDto }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerUpdateTestAttempt(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerUpdateTestAttemptMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerUpdateTestAttempt>>
>;
export type StudentsControllerUpdateTestAttemptMutationBody =
  StudentAttemptedExamsDto;
export type StudentsControllerUpdateTestAttemptMutationError = unknown;

export const useStudentsControllerUpdateTestAttempt = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerUpdateTestAttempt>>,
      TError,
      { data: StudentAttemptedExamsDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerUpdateTestAttempt>>,
  TError,
  { data: StudentAttemptedExamsDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerUpdateTestAttemptMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerCreateSelfTestCohort = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/students/self-test-cohort`, method: "POST", signal },
    options,
  );
};

export const getStudentsControllerCreateSelfTestCohortMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerCreateSelfTestCohort>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerCreateSelfTestCohort>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["studentsControllerCreateSelfTestCohort"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerCreateSelfTestCohort>>,
    void
  > = () => {
    return studentsControllerCreateSelfTestCohort(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerCreateSelfTestCohortMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerCreateSelfTestCohort>>
>;

export type StudentsControllerCreateSelfTestCohortMutationError = unknown;

export const useStudentsControllerCreateSelfTestCohort = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerCreateSelfTestCohort>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerCreateSelfTestCohort>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getStudentsControllerCreateSelfTestCohortMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetTestseries = (
  getTestSeriesDTO: GetTestSeriesDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/testseries/get`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getTestSeriesDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetTestseriesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetTestseries>>,
    TError,
    { data: GetTestSeriesDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetTestseries>>,
  TError,
  { data: GetTestSeriesDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerGetTestseries"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetTestseries>>,
    { data: GetTestSeriesDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetTestseries(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetTestseriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetTestseries>>
>;
export type StudentsControllerGetTestseriesMutationBody = GetTestSeriesDTO;
export type StudentsControllerGetTestseriesMutationError = unknown;

export const useStudentsControllerGetTestseries = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetTestseries>>,
      TError,
      { data: GetTestSeriesDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetTestseries>>,
  TError,
  { data: GetTestSeriesDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetTestseriesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetStudentUnscheduledTestseries = (
  getStudentUnscheduledTestseriesDTO: GetStudentUnscheduledTestseriesDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/unscheduled-testseries`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getStudentUnscheduledTestseriesDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetStudentUnscheduledTestseriesMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof studentsControllerGetStudentUnscheduledTestseries>
      >,
      TError,
      { data: GetStudentUnscheduledTestseriesDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof studentsControllerGetStudentUnscheduledTestseries>
    >,
    TError,
    { data: GetStudentUnscheduledTestseriesDTO },
    TContext
  > => {
    const mutationKey = ["studentsControllerGetStudentUnscheduledTestseries"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof studentsControllerGetStudentUnscheduledTestseries>
      >,
      { data: GetStudentUnscheduledTestseriesDTO }
    > = (props) => {
      const { data } = props ?? {};

      return studentsControllerGetStudentUnscheduledTestseries(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StudentsControllerGetStudentUnscheduledTestseriesMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof studentsControllerGetStudentUnscheduledTestseries>
    >
  >;
export type StudentsControllerGetStudentUnscheduledTestseriesMutationBody =
  GetStudentUnscheduledTestseriesDTO;
export type StudentsControllerGetStudentUnscheduledTestseriesMutationError =
  unknown;

export const useStudentsControllerGetStudentUnscheduledTestseries = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof studentsControllerGetStudentUnscheduledTestseries>
      >,
      TError,
      { data: GetStudentUnscheduledTestseriesDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetStudentUnscheduledTestseries>>,
  TError,
  { data: GetStudentUnscheduledTestseriesDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetStudentUnscheduledTestseriesMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerCreateCyotWithPaper = (
  createCyotPaperDTO: CreateCyotPaperDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/cyot-paper`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCyotPaperDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerCreateCyotWithPaperMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerCreateCyotWithPaper>>,
    TError,
    { data: CreateCyotPaperDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerCreateCyotWithPaper>>,
  TError,
  { data: CreateCyotPaperDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerCreateCyotWithPaper"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerCreateCyotWithPaper>>,
    { data: CreateCyotPaperDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerCreateCyotWithPaper(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerCreateCyotWithPaperMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerCreateCyotWithPaper>>
>;
export type StudentsControllerCreateCyotWithPaperMutationBody =
  CreateCyotPaperDTO;
export type StudentsControllerCreateCyotWithPaperMutationError = unknown;

export const useStudentsControllerCreateCyotWithPaper = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerCreateCyotWithPaper>>,
      TError,
      { data: CreateCyotPaperDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerCreateCyotWithPaper>>,
  TError,
  { data: CreateCyotPaperDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerCreateCyotWithPaperMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetCyotPapers = (
  getCyotPapersDTO: GetCyotPapersDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/cyot-papers`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getCyotPapersDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetCyotPapersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetCyotPapers>>,
    TError,
    { data: GetCyotPapersDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetCyotPapers>>,
  TError,
  { data: GetCyotPapersDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerGetCyotPapers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetCyotPapers>>,
    { data: GetCyotPapersDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetCyotPapers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetCyotPapersMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetCyotPapers>>
>;
export type StudentsControllerGetCyotPapersMutationBody = GetCyotPapersDTO;
export type StudentsControllerGetCyotPapersMutationError = unknown;

export const useStudentsControllerGetCyotPapers = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetCyotPapers>>,
      TError,
      { data: GetCyotPapersDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetCyotPapers>>,
  TError,
  { data: GetCyotPapersDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetCyotPapersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerSaveSharedCyotPapersDetails = (
  shareCyotPapersDTO: ShareCyotPapersDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/shared/cyot-papers`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: shareCyotPapersDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerSaveSharedCyotPapersDetailsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerSaveSharedCyotPapersDetails>>,
    TError,
    { data: ShareCyotPapersDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerSaveSharedCyotPapersDetails>>,
  TError,
  { data: ShareCyotPapersDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerSaveSharedCyotPapersDetails"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerSaveSharedCyotPapersDetails>>,
    { data: ShareCyotPapersDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerSaveSharedCyotPapersDetails(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerSaveSharedCyotPapersDetailsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof studentsControllerSaveSharedCyotPapersDetails>>
  >;
export type StudentsControllerSaveSharedCyotPapersDetailsMutationBody =
  ShareCyotPapersDTO;
export type StudentsControllerSaveSharedCyotPapersDetailsMutationError =
  unknown;

export const useStudentsControllerSaveSharedCyotPapersDetails = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerSaveSharedCyotPapersDetails>>,
      TError,
      { data: ShareCyotPapersDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerSaveSharedCyotPapersDetails>>,
  TError,
  { data: ShareCyotPapersDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerSaveSharedCyotPapersDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetDeepLinksTests = (
  getDeepLinksTestsDTO: GetDeepLinksTestsDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/deep-links/tests`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getDeepLinksTestsDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetDeepLinksTestsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetDeepLinksTests>>,
    TError,
    { data: GetDeepLinksTestsDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetDeepLinksTests>>,
  TError,
  { data: GetDeepLinksTestsDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerGetDeepLinksTests"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetDeepLinksTests>>,
    { data: GetDeepLinksTestsDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetDeepLinksTests(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetDeepLinksTestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetDeepLinksTests>>
>;
export type StudentsControllerGetDeepLinksTestsMutationBody =
  GetDeepLinksTestsDTO;
export type StudentsControllerGetDeepLinksTestsMutationError = unknown;

export const useStudentsControllerGetDeepLinksTests = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetDeepLinksTests>>,
      TError,
      { data: GetDeepLinksTestsDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetDeepLinksTests>>,
  TError,
  { data: GetDeepLinksTestsDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetDeepLinksTestsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetDeepLinksPrograms = (
  getDeepLinksProgramsDTO: GetDeepLinksProgramsDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/deep-links/programs`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getDeepLinksProgramsDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetDeepLinksProgramsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetDeepLinksPrograms>>,
    TError,
    { data: GetDeepLinksProgramsDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetDeepLinksPrograms>>,
  TError,
  { data: GetDeepLinksProgramsDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerGetDeepLinksPrograms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetDeepLinksPrograms>>,
    { data: GetDeepLinksProgramsDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetDeepLinksPrograms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetDeepLinksProgramsMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetDeepLinksPrograms>>
>;
export type StudentsControllerGetDeepLinksProgramsMutationBody =
  GetDeepLinksProgramsDTO;
export type StudentsControllerGetDeepLinksProgramsMutationError = unknown;

export const useStudentsControllerGetDeepLinksPrograms = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetDeepLinksPrograms>>,
      TError,
      { data: GetDeepLinksProgramsDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetDeepLinksPrograms>>,
  TError,
  { data: GetDeepLinksProgramsDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetDeepLinksProgramsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetStudentScheduleSummary = (
  getStudentScheduleSummaryDto: GetStudentScheduleSummaryDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/schedule-summary`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getStudentScheduleSummaryDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetStudentScheduleSummaryMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetStudentScheduleSummary>>,
    TError,
    { data: GetStudentScheduleSummaryDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetStudentScheduleSummary>>,
  TError,
  { data: GetStudentScheduleSummaryDto },
  TContext
> => {
  const mutationKey = ["studentsControllerGetStudentScheduleSummary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetStudentScheduleSummary>>,
    { data: GetStudentScheduleSummaryDto }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetStudentScheduleSummary(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetStudentScheduleSummaryMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof studentsControllerGetStudentScheduleSummary>>
  >;
export type StudentsControllerGetStudentScheduleSummaryMutationBody =
  GetStudentScheduleSummaryDto;
export type StudentsControllerGetStudentScheduleSummaryMutationError = unknown;

export const useStudentsControllerGetStudentScheduleSummary = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetStudentScheduleSummary>>,
      TError,
      { data: GetStudentScheduleSummaryDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetStudentScheduleSummary>>,
  TError,
  { data: GetStudentScheduleSummaryDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetStudentScheduleSummaryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetStudentToDosTests = (
  getStudentToDoTestsDto: GetStudentToDoTestsDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/to-do/tests`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getStudentToDoTestsDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetStudentToDosTestsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetStudentToDosTests>>,
    TError,
    { data: GetStudentToDoTestsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetStudentToDosTests>>,
  TError,
  { data: GetStudentToDoTestsDto },
  TContext
> => {
  const mutationKey = ["studentsControllerGetStudentToDosTests"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetStudentToDosTests>>,
    { data: GetStudentToDoTestsDto }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetStudentToDosTests(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetStudentToDosTestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetStudentToDosTests>>
>;
export type StudentsControllerGetStudentToDosTestsMutationBody =
  GetStudentToDoTestsDto;
export type StudentsControllerGetStudentToDosTestsMutationError = unknown;

export const useStudentsControllerGetStudentToDosTests = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetStudentToDosTests>>,
      TError,
      { data: GetStudentToDoTestsDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetStudentToDosTests>>,
  TError,
  { data: GetStudentToDoTestsDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetStudentToDosTestsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetStudentToDosClassesAndAssignments = (
  getStudentToDoClassesAssignmentsDto: GetStudentToDoClassesAssignmentsDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/to-do/classes-assignments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getStudentToDoClassesAssignmentsDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetStudentToDosClassesAndAssignmentsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof studentsControllerGetStudentToDosClassesAndAssignments
        >
      >,
      TError,
      { data: GetStudentToDoClassesAssignmentsDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof studentsControllerGetStudentToDosClassesAndAssignments>
    >,
    TError,
    { data: GetStudentToDoClassesAssignmentsDto },
    TContext
  > => {
    const mutationKey = [
      "studentsControllerGetStudentToDosClassesAndAssignments",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof studentsControllerGetStudentToDosClassesAndAssignments
        >
      >,
      { data: GetStudentToDoClassesAssignmentsDto }
    > = (props) => {
      const { data } = props ?? {};

      return studentsControllerGetStudentToDosClassesAndAssignments(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StudentsControllerGetStudentToDosClassesAndAssignmentsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof studentsControllerGetStudentToDosClassesAndAssignments>
    >
  >;
export type StudentsControllerGetStudentToDosClassesAndAssignmentsMutationBody =
  GetStudentToDoClassesAssignmentsDto;
export type StudentsControllerGetStudentToDosClassesAndAssignmentsMutationError =
  unknown;

export const useStudentsControllerGetStudentToDosClassesAndAssignments = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof studentsControllerGetStudentToDosClassesAndAssignments
        >
      >,
      TError,
      { data: GetStudentToDoClassesAssignmentsDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof studentsControllerGetStudentToDosClassesAndAssignments>
  >,
  TError,
  { data: GetStudentToDoClassesAssignmentsDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetStudentToDosClassesAndAssignmentsMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetStudentsCardsData = (
  getStudentsCardsDTO: GetStudentsCardsDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/cards`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getStudentsCardsDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetStudentsCardsDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetStudentsCardsData>>,
    TError,
    { data: GetStudentsCardsDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetStudentsCardsData>>,
  TError,
  { data: GetStudentsCardsDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerGetStudentsCardsData"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetStudentsCardsData>>,
    { data: GetStudentsCardsDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetStudentsCardsData(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetStudentsCardsDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetStudentsCardsData>>
>;
export type StudentsControllerGetStudentsCardsDataMutationBody =
  GetStudentsCardsDTO;
export type StudentsControllerGetStudentsCardsDataMutationError = unknown;

export const useStudentsControllerGetStudentsCardsData = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetStudentsCardsData>>,
      TError,
      { data: GetStudentsCardsDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetStudentsCardsData>>,
  TError,
  { data: GetStudentsCardsDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetStudentsCardsDataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetStudentSubscriptionComponents = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/students/subscription-type-components`, method: "GET", signal },
    options,
  );
};

export const getStudentsControllerGetStudentSubscriptionComponentsQueryKey =
  () => {
    return [`/students/subscription-type-components`] as const;
  };

export const getStudentsControllerGetStudentSubscriptionComponentsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
    >,
    TError = unknown,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getStudentsControllerGetStudentSubscriptionComponentsQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
      >
    > = ({ signal }) =>
      studentsControllerGetStudentSubscriptionComponents(
        requestOptions,
        signal,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type StudentsControllerGetStudentSubscriptionComponentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
    >
  >;
export type StudentsControllerGetStudentSubscriptionComponentsQueryError =
  unknown;

export function useStudentsControllerGetStudentSubscriptionComponents<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
  >,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof studentsControllerGetStudentSubscriptionComponents
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof studentsControllerGetStudentSubscriptionComponents
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetStudentSubscriptionComponents<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof studentsControllerGetStudentSubscriptionComponents
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof studentsControllerGetStudentSubscriptionComponents
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetStudentSubscriptionComponents<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useStudentsControllerGetStudentSubscriptionComponents<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetStudentSubscriptionComponents>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getStudentsControllerGetStudentSubscriptionComponentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const studentsControllerGetCohortsGuidelinesConfig = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/students/cohorts-guidelines-config`, method: "GET", signal },
    options,
  );
};

export const getStudentsControllerGetCohortsGuidelinesConfigQueryKey = () => {
  return [`/students/cohorts-guidelines-config`] as const;
};

export const getStudentsControllerGetCohortsGuidelinesConfigQueryOptions = <
  TData = Awaited<
    ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStudentsControllerGetCohortsGuidelinesConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>>
  > = ({ signal }) =>
    studentsControllerGetCohortsGuidelinesConfig(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StudentsControllerGetCohortsGuidelinesConfigQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>>
  >;
export type StudentsControllerGetCohortsGuidelinesConfigQueryError = unknown;

export function useStudentsControllerGetCohortsGuidelinesConfig<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
  >,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
          >,
          TError,
          Awaited<
            ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetCohortsGuidelinesConfig<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
          >,
          TError,
          Awaited<
            ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetCohortsGuidelinesConfig<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useStudentsControllerGetCohortsGuidelinesConfig<
  TData = Awaited<
    ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof studentsControllerGetCohortsGuidelinesConfig>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getStudentsControllerGetCohortsGuidelinesConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get active banners for specific criteria
 */
export const studentsControllerFindActiveBanners = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/students/banners/active`, method: "GET", signal },
    options,
  );
};

export const getStudentsControllerFindActiveBannersQueryKey = () => {
  return [`/students/banners/active`] as const;
};

export const getStudentsControllerFindActiveBannersQueryOptions = <
  TData = Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStudentsControllerFindActiveBannersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>
  > = ({ signal }) =>
    studentsControllerFindActiveBanners(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StudentsControllerFindActiveBannersQueryResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>
>;
export type StudentsControllerFindActiveBannersQueryError = unknown;

export function useStudentsControllerFindActiveBanners<
  TData = Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerFindActiveBanners<
  TData = Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerFindActiveBanners<
  TData = Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get active banners for specific criteria
 */

export function useStudentsControllerFindActiveBanners<
  TData = Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerFindActiveBanners>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getStudentsControllerFindActiveBannersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const studentsControllerSaveGuidelinesPreferences = (
  saveStudentsGuidelinesPreferencesDTO: SaveStudentsGuidelinesPreferencesDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/guidelines-preferences`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveStudentsGuidelinesPreferencesDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerSaveGuidelinesPreferencesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerSaveGuidelinesPreferences>>,
    TError,
    { data: SaveStudentsGuidelinesPreferencesDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerSaveGuidelinesPreferences>>,
  TError,
  { data: SaveStudentsGuidelinesPreferencesDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerSaveGuidelinesPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerSaveGuidelinesPreferences>>,
    { data: SaveStudentsGuidelinesPreferencesDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerSaveGuidelinesPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerSaveGuidelinesPreferencesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof studentsControllerSaveGuidelinesPreferences>>
  >;
export type StudentsControllerSaveGuidelinesPreferencesMutationBody =
  SaveStudentsGuidelinesPreferencesDTO;
export type StudentsControllerSaveGuidelinesPreferencesMutationError = unknown;

export const useStudentsControllerSaveGuidelinesPreferences = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerSaveGuidelinesPreferences>>,
      TError,
      { data: SaveStudentsGuidelinesPreferencesDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerSaveGuidelinesPreferences>>,
  TError,
  { data: SaveStudentsGuidelinesPreferencesDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerSaveGuidelinesPreferencesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetSuggestedPrograms = (
  getSuggestedProgramsDTO: GetSuggestedProgramsDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/suggested-programs`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getSuggestedProgramsDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetSuggestedProgramsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetSuggestedPrograms>>,
    TError,
    { data: GetSuggestedProgramsDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetSuggestedPrograms>>,
  TError,
  { data: GetSuggestedProgramsDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerGetSuggestedPrograms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetSuggestedPrograms>>,
    { data: GetSuggestedProgramsDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetSuggestedPrograms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetSuggestedProgramsMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetSuggestedPrograms>>
>;
export type StudentsControllerGetSuggestedProgramsMutationBody =
  GetSuggestedProgramsDTO;
export type StudentsControllerGetSuggestedProgramsMutationError = unknown;

export const useStudentsControllerGetSuggestedPrograms = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetSuggestedPrograms>>,
      TError,
      { data: GetSuggestedProgramsDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetSuggestedPrograms>>,
  TError,
  { data: GetSuggestedProgramsDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetSuggestedProgramsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Send AINA analytics / telemetry event
 */
export const studentsControllerSaveAinaEvents = (
  ainaRequestBody: AinaRequestBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AinaEventResponse>(
    {
      url: `/students/aina-events`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: ainaRequestBody,
      signal,
    },
    options,
  );
};

export const getStudentsControllerSaveAinaEventsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerSaveAinaEvents>>,
    TError,
    { data: AinaRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerSaveAinaEvents>>,
  TError,
  { data: AinaRequestBody },
  TContext
> => {
  const mutationKey = ["studentsControllerSaveAinaEvents"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerSaveAinaEvents>>,
    { data: AinaRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerSaveAinaEvents(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerSaveAinaEventsMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerSaveAinaEvents>>
>;
export type StudentsControllerSaveAinaEventsMutationBody = AinaRequestBody;
export type StudentsControllerSaveAinaEventsMutationError = unknown;

/**
 * @summary Send AINA analytics / telemetry event
 */
export const useStudentsControllerSaveAinaEvents = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerSaveAinaEvents>>,
      TError,
      { data: AinaRequestBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerSaveAinaEvents>>,
  TError,
  { data: AinaRequestBody },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerSaveAinaEventsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetDeepLink = (
  params: StudentsControllerGetDeepLinkParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/students/deeplink`, method: "GET", params, signal },
    options,
  );
};

export const getStudentsControllerGetDeepLinkQueryKey = (
  params?: StudentsControllerGetDeepLinkParams,
) => {
  return [`/students/deeplink`, ...(params ? [params] : [])] as const;
};

export const getStudentsControllerGetDeepLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
  TError = unknown,
>(
  params: StudentsControllerGetDeepLinkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStudentsControllerGetDeepLinkQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof studentsControllerGetDeepLink>>
  > = ({ signal }) =>
    studentsControllerGetDeepLink(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StudentsControllerGetDeepLinkQueryResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetDeepLink>>
>;
export type StudentsControllerGetDeepLinkQueryError = unknown;

export function useStudentsControllerGetDeepLink<
  TData = Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
  TError = unknown,
>(
  params: StudentsControllerGetDeepLinkParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerGetDeepLink>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetDeepLink<
  TData = Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
  TError = unknown,
>(
  params: StudentsControllerGetDeepLinkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
          TError,
          Awaited<ReturnType<typeof studentsControllerGetDeepLink>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStudentsControllerGetDeepLink<
  TData = Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
  TError = unknown,
>(
  params: StudentsControllerGetDeepLinkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useStudentsControllerGetDeepLink<
  TData = Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
  TError = unknown,
>(
  params: StudentsControllerGetDeepLinkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof studentsControllerGetDeepLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getStudentsControllerGetDeepLinkQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const studentsControllerGetBasicReport = (
  getBasicExamReportDTO: GetBasicExamReportDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/exam-report/data`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getBasicExamReportDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetBasicReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetBasicReport>>,
    TError,
    { data: GetBasicExamReportDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetBasicReport>>,
  TError,
  { data: GetBasicExamReportDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerGetBasicReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetBasicReport>>,
    { data: GetBasicExamReportDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetBasicReport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetBasicReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetBasicReport>>
>;
export type StudentsControllerGetBasicReportMutationBody =
  GetBasicExamReportDTO;
export type StudentsControllerGetBasicReportMutationError = unknown;

export const useStudentsControllerGetBasicReport = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetBasicReport>>,
      TError,
      { data: GetBasicExamReportDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetBasicReport>>,
  TError,
  { data: GetBasicExamReportDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetBasicReportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetExamReports = (
  getExamReportsDTO: GetExamReportsDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/exam-report`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getExamReportsDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetExamReportsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetExamReports>>,
    TError,
    { data: GetExamReportsDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetExamReports>>,
  TError,
  { data: GetExamReportsDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerGetExamReports"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetExamReports>>,
    { data: GetExamReportsDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetExamReports(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetExamReportsMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetExamReports>>
>;
export type StudentsControllerGetExamReportsMutationBody = GetExamReportsDTO;
export type StudentsControllerGetExamReportsMutationError = unknown;

export const useStudentsControllerGetExamReports = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetExamReports>>,
      TError,
      { data: GetExamReportsDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetExamReports>>,
  TError,
  { data: GetExamReportsDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetExamReportsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerCreate = (
  saveStudentfeedbackDTO: SaveStudentfeedbackDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/feedback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveStudentfeedbackDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerCreate>>,
    TError,
    { data: SaveStudentfeedbackDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerCreate>>,
  TError,
  { data: SaveStudentfeedbackDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerCreate>>,
    { data: SaveStudentfeedbackDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerCreate>>
>;
export type StudentsControllerCreateMutationBody = SaveStudentfeedbackDTO;
export type StudentsControllerCreateMutationError = unknown;

export const useStudentsControllerCreate = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerCreate>>,
      TError,
      { data: SaveStudentfeedbackDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerCreate>>,
  TError,
  { data: SaveStudentfeedbackDTO },
  TContext
> => {
  const mutationOptions = getStudentsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerSaveStudentExamApplication = (
  saveStudentExamApplicationDto: SaveStudentExamApplicationDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/exam-application`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveStudentExamApplicationDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerSaveStudentExamApplicationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerSaveStudentExamApplication>>,
    TError,
    { data: SaveStudentExamApplicationDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerSaveStudentExamApplication>>,
  TError,
  { data: SaveStudentExamApplicationDto },
  TContext
> => {
  const mutationKey = ["studentsControllerSaveStudentExamApplication"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerSaveStudentExamApplication>>,
    { data: SaveStudentExamApplicationDto }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerSaveStudentExamApplication(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerSaveStudentExamApplicationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof studentsControllerSaveStudentExamApplication>>
  >;
export type StudentsControllerSaveStudentExamApplicationMutationBody =
  SaveStudentExamApplicationDto;
export type StudentsControllerSaveStudentExamApplicationMutationError = unknown;

export const useStudentsControllerSaveStudentExamApplication = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerSaveStudentExamApplication>>,
      TError,
      { data: SaveStudentExamApplicationDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerSaveStudentExamApplication>>,
  TError,
  { data: SaveStudentExamApplicationDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerSaveStudentExamApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetPopups = (
  createPopupDTO: CreatePopupDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/can-show-popup`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPopupDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetPopupsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetPopups>>,
    TError,
    { data: CreatePopupDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetPopups>>,
  TError,
  { data: CreatePopupDTO },
  TContext
> => {
  const mutationKey = ["studentsControllerGetPopups"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetPopups>>,
    { data: CreatePopupDTO }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetPopups(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetPopupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetPopups>>
>;
export type StudentsControllerGetPopupsMutationBody = CreatePopupDTO;
export type StudentsControllerGetPopupsMutationError = unknown;

export const useStudentsControllerGetPopups = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetPopups>>,
      TError,
      { data: CreatePopupDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetPopups>>,
  TError,
  { data: CreatePopupDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetPopupsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetsuspiciousActivity = (
  updateSuspiciousActivityDto: UpdateSuspiciousActivityDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/suspiciousActivity`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateSuspiciousActivityDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetsuspiciousActivityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerGetsuspiciousActivity>>,
    TError,
    { data: UpdateSuspiciousActivityDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerGetsuspiciousActivity>>,
  TError,
  { data: UpdateSuspiciousActivityDto },
  TContext
> => {
  const mutationKey = ["studentsControllerGetsuspiciousActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerGetsuspiciousActivity>>,
    { data: UpdateSuspiciousActivityDto }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerGetsuspiciousActivity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerGetsuspiciousActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerGetsuspiciousActivity>>
>;
export type StudentsControllerGetsuspiciousActivityMutationBody =
  UpdateSuspiciousActivityDto;
export type StudentsControllerGetsuspiciousActivityMutationError = unknown;

export const useStudentsControllerGetsuspiciousActivity = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerGetsuspiciousActivity>>,
      TError,
      { data: UpdateSuspiciousActivityDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetsuspiciousActivity>>,
  TError,
  { data: UpdateSuspiciousActivityDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetsuspiciousActivityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerCreatesuspiciousActivity = (
  updateSuspiciousActivityDto: UpdateSuspiciousActivityDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/suspiciousActivity`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateSuspiciousActivityDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerCreatesuspiciousActivityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerCreatesuspiciousActivity>>,
    TError,
    { data: UpdateSuspiciousActivityDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerCreatesuspiciousActivity>>,
  TError,
  { data: UpdateSuspiciousActivityDto },
  TContext
> => {
  const mutationKey = ["studentsControllerCreatesuspiciousActivity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerCreatesuspiciousActivity>>,
    { data: UpdateSuspiciousActivityDto }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerCreatesuspiciousActivity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerCreatesuspiciousActivityMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof studentsControllerCreatesuspiciousActivity>>
  >;
export type StudentsControllerCreatesuspiciousActivityMutationBody =
  UpdateSuspiciousActivityDto;
export type StudentsControllerCreatesuspiciousActivityMutationError = unknown;

export const useStudentsControllerCreatesuspiciousActivity = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerCreatesuspiciousActivity>>,
      TError,
      { data: UpdateSuspiciousActivityDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerCreatesuspiciousActivity>>,
  TError,
  { data: UpdateSuspiciousActivityDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerCreatesuspiciousActivityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerSaveStudentCurrentProgram = (
  saveStudentsCurrentProgramsDto: SaveStudentsCurrentProgramsDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/current-program`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveStudentsCurrentProgramsDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerSaveStudentCurrentProgramMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerSaveStudentCurrentProgram>>,
    TError,
    { data: SaveStudentsCurrentProgramsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerSaveStudentCurrentProgram>>,
  TError,
  { data: SaveStudentsCurrentProgramsDto },
  TContext
> => {
  const mutationKey = ["studentsControllerSaveStudentCurrentProgram"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerSaveStudentCurrentProgram>>,
    { data: SaveStudentsCurrentProgramsDto }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerSaveStudentCurrentProgram(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerSaveStudentCurrentProgramMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof studentsControllerSaveStudentCurrentProgram>>
  >;
export type StudentsControllerSaveStudentCurrentProgramMutationBody =
  SaveStudentsCurrentProgramsDto;
export type StudentsControllerSaveStudentCurrentProgramMutationError = unknown;

export const useStudentsControllerSaveStudentCurrentProgram = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerSaveStudentCurrentProgram>>,
      TError,
      { data: SaveStudentsCurrentProgramsDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerSaveStudentCurrentProgram>>,
  TError,
  { data: SaveStudentsCurrentProgramsDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerSaveStudentCurrentProgramMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerFetchMyPastClasses = (
  getMyPastClasses: GetMyPastClasses,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/my-past-classes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getMyPastClasses,
      signal,
    },
    options,
  );
};

export const getStudentsControllerFetchMyPastClassesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof studentsControllerFetchMyPastClasses>>,
    TError,
    { data: GetMyPastClasses },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof studentsControllerFetchMyPastClasses>>,
  TError,
  { data: GetMyPastClasses },
  TContext
> => {
  const mutationKey = ["studentsControllerFetchMyPastClasses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof studentsControllerFetchMyPastClasses>>,
    { data: GetMyPastClasses }
  > = (props) => {
    const { data } = props ?? {};

    return studentsControllerFetchMyPastClasses(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StudentsControllerFetchMyPastClassesMutationResult = NonNullable<
  Awaited<ReturnType<typeof studentsControllerFetchMyPastClasses>>
>;
export type StudentsControllerFetchMyPastClassesMutationBody = GetMyPastClasses;
export type StudentsControllerFetchMyPastClassesMutationError = unknown;

export const useStudentsControllerFetchMyPastClasses = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof studentsControllerFetchMyPastClasses>>,
      TError,
      { data: GetMyPastClasses },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerFetchMyPastClasses>>,
  TError,
  { data: GetMyPastClasses },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerFetchMyPastClassesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetStudentProgramsLiveClassCohortHistory = (
  getProgramsLiveClassCohortHistoryDTO: GetProgramsLiveClassCohortHistoryDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/live-class-cohort-history`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getProgramsLiveClassCohortHistoryDTO,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetStudentProgramsLiveClassCohortHistoryMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof studentsControllerGetStudentProgramsLiveClassCohortHistory
        >
      >,
      TError,
      { data: GetProgramsLiveClassCohortHistoryDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof studentsControllerGetStudentProgramsLiveClassCohortHistory
      >
    >,
    TError,
    { data: GetProgramsLiveClassCohortHistoryDTO },
    TContext
  > => {
    const mutationKey = [
      "studentsControllerGetStudentProgramsLiveClassCohortHistory",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof studentsControllerGetStudentProgramsLiveClassCohortHistory
        >
      >,
      { data: GetProgramsLiveClassCohortHistoryDTO }
    > = (props) => {
      const { data } = props ?? {};

      return studentsControllerGetStudentProgramsLiveClassCohortHistory(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StudentsControllerGetStudentProgramsLiveClassCohortHistoryMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof studentsControllerGetStudentProgramsLiveClassCohortHistory
      >
    >
  >;
export type StudentsControllerGetStudentProgramsLiveClassCohortHistoryMutationBody =
  GetProgramsLiveClassCohortHistoryDTO;
export type StudentsControllerGetStudentProgramsLiveClassCohortHistoryMutationError =
  unknown;

export const useStudentsControllerGetStudentProgramsLiveClassCohortHistory = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof studentsControllerGetStudentProgramsLiveClassCohortHistory
        >
      >,
      TError,
      { data: GetProgramsLiveClassCohortHistoryDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof studentsControllerGetStudentProgramsLiveClassCohortHistory
    >
  >,
  TError,
  { data: GetProgramsLiveClassCohortHistoryDTO },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetStudentProgramsLiveClassCohortHistoryMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetStudentPastClassesByTimeLine = (
  classesByTimelineRequestDto: ClassesByTimelineRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/past-classes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: classesByTimelineRequestDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetStudentPastClassesByTimeLineMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof studentsControllerGetStudentPastClassesByTimeLine>
      >,
      TError,
      { data: ClassesByTimelineRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof studentsControllerGetStudentPastClassesByTimeLine>
    >,
    TError,
    { data: ClassesByTimelineRequestDto },
    TContext
  > => {
    const mutationKey = ["studentsControllerGetStudentPastClassesByTimeLine"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof studentsControllerGetStudentPastClassesByTimeLine>
      >,
      { data: ClassesByTimelineRequestDto }
    > = (props) => {
      const { data } = props ?? {};

      return studentsControllerGetStudentPastClassesByTimeLine(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StudentsControllerGetStudentPastClassesByTimeLineMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof studentsControllerGetStudentPastClassesByTimeLine>
    >
  >;
export type StudentsControllerGetStudentPastClassesByTimeLineMutationBody =
  ClassesByTimelineRequestDto;
export type StudentsControllerGetStudentPastClassesByTimeLineMutationError =
  unknown;

export const useStudentsControllerGetStudentPastClassesByTimeLine = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof studentsControllerGetStudentPastClassesByTimeLine>
      >,
      TError,
      { data: ClassesByTimelineRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof studentsControllerGetStudentPastClassesByTimeLine>>,
  TError,
  { data: ClassesByTimelineRequestDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetStudentPastClassesByTimeLineMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerGetStudentOngoingUpcomingClassesByTimeLine = (
  classesByTimelineRequestDto: ClassesByTimelineRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/get/ongoing-upcoming-classes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: classesByTimelineRequestDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerGetStudentOngoingUpcomingClassesByTimeLineMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof studentsControllerGetStudentOngoingUpcomingClassesByTimeLine
        >
      >,
      TError,
      { data: ClassesByTimelineRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof studentsControllerGetStudentOngoingUpcomingClassesByTimeLine
      >
    >,
    TError,
    { data: ClassesByTimelineRequestDto },
    TContext
  > => {
    const mutationKey = [
      "studentsControllerGetStudentOngoingUpcomingClassesByTimeLine",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof studentsControllerGetStudentOngoingUpcomingClassesByTimeLine
        >
      >,
      { data: ClassesByTimelineRequestDto }
    > = (props) => {
      const { data } = props ?? {};

      return studentsControllerGetStudentOngoingUpcomingClassesByTimeLine(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StudentsControllerGetStudentOngoingUpcomingClassesByTimeLineMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof studentsControllerGetStudentOngoingUpcomingClassesByTimeLine
      >
    >
  >;
export type StudentsControllerGetStudentOngoingUpcomingClassesByTimeLineMutationBody =
  ClassesByTimelineRequestDto;
export type StudentsControllerGetStudentOngoingUpcomingClassesByTimeLineMutationError =
  unknown;

export const useStudentsControllerGetStudentOngoingUpcomingClassesByTimeLine = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof studentsControllerGetStudentOngoingUpcomingClassesByTimeLine
        >
      >,
      TError,
      { data: ClassesByTimelineRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof studentsControllerGetStudentOngoingUpcomingClassesByTimeLine
    >
  >,
  TError,
  { data: ClassesByTimelineRequestDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerGetStudentOngoingUpcomingClassesByTimeLineMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
export const studentsControllerTriggerLiveClassEventsToWebengage = (
  triggerLiveClassEventsToWebengageDto: TriggerLiveClassEventsToWebengageDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/students/trigger/live-class-events`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: triggerLiveClassEventsToWebengageDto,
      signal,
    },
    options,
  );
};

export const getStudentsControllerTriggerLiveClassEventsToWebengageMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof studentsControllerTriggerLiveClassEventsToWebengage>
      >,
      TError,
      { data: TriggerLiveClassEventsToWebengageDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof studentsControllerTriggerLiveClassEventsToWebengage>
    >,
    TError,
    { data: TriggerLiveClassEventsToWebengageDto },
    TContext
  > => {
    const mutationKey = ["studentsControllerTriggerLiveClassEventsToWebengage"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof studentsControllerTriggerLiveClassEventsToWebengage>
      >,
      { data: TriggerLiveClassEventsToWebengageDto }
    > = (props) => {
      const { data } = props ?? {};

      return studentsControllerTriggerLiveClassEventsToWebengage(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StudentsControllerTriggerLiveClassEventsToWebengageMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof studentsControllerTriggerLiveClassEventsToWebengage>
    >
  >;
export type StudentsControllerTriggerLiveClassEventsToWebengageMutationBody =
  TriggerLiveClassEventsToWebengageDto;
export type StudentsControllerTriggerLiveClassEventsToWebengageMutationError =
  unknown;

export const useStudentsControllerTriggerLiveClassEventsToWebengage = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof studentsControllerTriggerLiveClassEventsToWebengage>
      >,
      TError,
      { data: TriggerLiveClassEventsToWebengageDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof studentsControllerTriggerLiveClassEventsToWebengage>
  >,
  TError,
  { data: TriggerLiveClassEventsToWebengageDto },
  TContext
> => {
  const mutationOptions =
    getStudentsControllerTriggerLiveClassEventsToWebengageMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
